module.exports = __webpack_public_path__ + "static/img/index.1fe2c3ab.svg";